export default "__VITE_ASSET__CuZaU6Dg__"